export function initDropdownSearch(o) {
    const searchInput = o.el.querySelector('.searchInput');
    const optionsList = o.el.querySelector('.optionsList');
    const options = optionsList.getElementsByTagName('li');
    searchInput.addEventListener('input', function() {
        const searchTerm = this.value.toLowerCase();
        console.log('searchTerm', searchTerm)
        optionsList.style.display = 'block'; // Show dropdown when typing

        for (let i = 0; i < options.length; i++) {
            const optionText = options[i].textContent.toLowerCase();
            if (optionText.includes(searchTerm)) {
                options[i].style.display = ''; // Show matching options
            } else {
                options[i].style.display = 'none'; // Hide non-matching options
            }
        }
    });

    searchInput.addEventListener("click", function() {
        optionsList.style.display = 'block';
    })

    // Hide dropdown when clicking outside
    document.addEventListener('click', function(event) {
        if (!event.target.closest('.searchable-dropdown')) {
            optionsList.style.display = 'none';
        }
    });

    // Handle option selection (example: log to console)
    optionsList.addEventListener('click', function(event) {
        if (event.target.tagName === 'LI') {
            searchInput.value = event.target.dataset.value; // Set input to selected option
            optionsList.style.display = 'none'; // Hide dropdown after selection
            searchInput.dispatchEvent(new Event('change'));
        }
    });
}